import type { ComponentProps } from "react";

import { cx } from "./cx";

/** A row of controls. Every direct child gets `flex-1`, so two buttons come out equal. */
export function Row({ className, ...rest }: ComponentProps<"div">) {
  return <div className={cx("flex gap-row mt-4 *:flex-1", className)} {...rest} />;
}
